import config from "@/config/config";
import type { K3Credentials, K3Session } from "@/core/auth/adapter";
import type { AuthAdapter } from "@k3-tech/react-kit";
import { TanstackDevtools } from "@tanstack/react-devtools";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools";

export const Route = createRootRouteWithContext<{
  authAdapter: AuthAdapter<unknown, string, string, K3Session, K3Credentials>
}>()({
  // Vendor route (/vendor) owns its own auth guard; the standalone vendor app
  // has no /admin surface, so the root only renders the outlet.
  component: () => (
    <>
      <Outlet />
      {config.ENABLE_TANSTACK_DEVTOOLS && (
        <TanstackDevtools
          config={{
            position: "bottom-right",
          }}
          plugins={[
            {
              name: "Tanstack Router",
              render: <TanStackRouterDevtoolsPanel />,
            },
          ]}
        />
      )}
    </>
  ),
});
